<template>
    <v-layout justify-center row>
        <v-dialog max-width="500px" persistent v-model="dialog">
            <v-card>
                <v-card-title class="justify-center white--text secondary" >
                    <span class="headline">Αρχικοποίηση στοιχείων</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout align-space-around column fill-height justify-space-around>
                            <v-form
                                    @submit.prevent
                                    lazy-validation
                                    ref="form"
                                    v-model="valid">
                                <v-flex xs12>
                                    <v-text-field :rules="emailRules" clearable label="Προσωπικό E-mail Επικοινωνίας"
                                                  prepend-inner-icon="email" required
                                                  v-model="email"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field :counter="10" :rules="phoneRules" clearable
                                                  label="Αριθμός Κινητού Τηλεφώνου" prepend-inner-icon="phone" required
                                                  v-model="mobile"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field :rules="semesterRules" clearable
                                                  :disabled="checkIfSemesterIsEmpty()"
                                                  label="Τρεχον Εξαμηνο" prepend-inner-icon="book" required
                                                  v-model="semester"></v-text-field>
                                </v-flex>

                            </v-form>
                        </v-layout>
                    </v-container>
                    <small>* <i>Τα στοιχεία αλλάζουν μόνο κατά την αποθήκευση</i></small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="save" color="primary darken-1" flat>Αποθήκευση</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import requests from "../../requests";

    export default {
        name: "InitializationComponent",
        data: () => ({
            dialog: true,
            mobile: '',
            email: '',
            semester:'',
            valid: false,
            emailRules: [
                v => !!v || 'Το email είναι απαραίτητο ',
                v => /^[A-Za-z][-.\w]*@([-\w]+\.)+[A-Za-z]{2,}$/.test(v) || 'Το email δεν είναι έγκυρο'
            ],
            phoneRules: [
                v => !!v || 'Το τηλέφωνο είναι απαραίτητο',
                v => /^69[0-9]{8}$/.test(v) || 'Το τηλέφωνο δεν είναι έγκυρο'
            ],
            semesterRules: [
                v => !! 'Το εξάμηνο είναι απαραίτητο',
                v => /^[1-9][0-9]?$/.test(v) || 'Το εξάμηνο δεν είναι έγκυρο'
            ]
        }),
        methods: {
            saveCredentialsSuccess(response) {
                // var loginObject = this.$store.getters.login;
                // loginObject.personalEmail = response.personalEmail;
                // loginObject.mobile = response.mobile;
                // loginObject.courseCountBeforeEudoxos = response.courseCountBeforeEudoxos;
                // loginObject.currentSemester = response.currentSemester;
                // loginObject.statementMaxCourseSemester  = response.statementMaxCourseSemester;
                this.$store.commit('setLogin', response);
                this.$emit('changeCredentials');
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setInitializationFlag', false);
            },
            save() {

                var courseCountBeforeEudoxos = 0;
                if (this.$store.getters.login.hasOwnProperty("courseCountBeforeEudoxos")) {
                    courseCountBeforeEudoxos = this.$store.getters.login.courseCountBeforeEudoxos;
                }

                if(this.validateEmail() && this.validateMobile() && this.validateSemester()){
                    this.$store.commit('setLoadingModal', true);
                    let requestCredentials = {
                        email: this.email,
                        mobile: this.mobile,
                        courseCountBeforeEudoxos: courseCountBeforeEudoxos,
                        currentSemester: this.semester,
                        hasAcceptedSecondTerm: false
                    };
                    requests.saveCredentials(requestCredentials, this.saveCredentialsSuccess);
                    // this.$refs.form.resetValidation();
                    // this.$refs.form.reset();
                }
                else if(!this.validateEmail()) {
                    alert("Το email δεν είναι έγκυρο");
                    this.email = '';
                }
                else if(!this.validateMobile()){
                    alert('Το τηλέφωνο δεν είναι έγκυρο');
                    this.mobile = '';
                }
                else if(!this.validateSemester()){
                    alert('Το εξάμηνο δεν είναι έγκυρο');
                    this.semester = '';
                }

            },
            validateEmail() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(this.email).toLowerCase());
            },
            validateMobile(){
                var re = /^69[0-9]{8}$/;
                return re.test(this.mobile);
            },
            validateSemester(){
                var re = /^[1-9][0-9]?$/;
                return re.test(this.semester);
            },
            checkIfSemesterIsEmpty(){
                var login = this.$store.getters.login;
                if(login.hasOwnProperty("currentSemester") && !login.currentSemester == ''){
                    return true
                }
            }
        },
        mounted(){
            this.email = this.$store.getters.login.personalEmail;
            this.mobile = this.$store.getters.login.mobile;
            this.semester = this.$store.getters.login.currentSemester;
        }
    }
</script>

<style scoped>

</style>